
import { defineComponent, ref } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import WarningIcon from '@/components/ui-elements/icons/WarningIcon.vue';

export default defineComponent({
	components: {
		Modal,
		WarningIcon,
	},
	props: {
		show: {
			required: true,
			type: Boolean,
		},
		text: {
			default: 'Are you sure you want to remove this item?',
			type: String,
		},
		title: {
			default: 'Remove Item',
			type: String,
		},
	},
	setup(props, { emit }) {
		const setClose = ref(false);

		const setCloseModal = (e: boolean) => {
			if (e) {
				emit('confirm');
			}

			setClose.value = true;
			setTimeout(() => (setClose.value = false), 1000);
		};

		return {
			closeModal: (e: boolean) => emit('update:show', e),
			setClose,
			setCloseModal,
		};
	},
});
